import { useRemoveUsersFromGroupMutation } from '../../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useRemoveUserHandler() {
	const [ removeUsersFromGroupMutation ] = useRemoveUsersFromGroupMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( group: { id: number }, userId: number ) => {
		const groupId = group.id
		const userIds = [ userId ]

		const result = await removeUsersFromGroupMutation( { variables: { userIds, groupId } } )
		if ( result.data?.removeUsersFromGroup?.success ) {
			showSuccess( `removeUsersFromGroupSuccess${Date.now()}`, result.data?.removeUsersFromGroup?.message ?? 'Successfully removed user(s) from group!' )
		} else {
			showError( `removeUsersFromGroupError${Date.now()}`, result.data?.removeUsersFromGroup?.message ?? 'Sorry, an error occurred' )
		}
	}
}
